import React, { ChangeEvent, useState } from "react";
import "./UploadFile.scss";
import { ProgressBar } from "../../../components";
import { useTypeSelector } from "../../../hooks/useTypeSelector";
import { useActions } from "../../../hooks/useActions";
import { NotificationSend } from "../../../utils/Notification/Notification";

export const UploadFile = (): JSX.Element => {
  const [isFilePicked, setIsFilePicked] = useState(false);
  const [progress, setProgress] = useState(0);

  const { success } = useTypeSelector((state) => state.upload);
  const { uploadFile } = useActions();

  const changeHandler = (e: ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    if (e.target.files) {
      setIsFilePicked(true);
      setProgress(0);
      NotificationSend("info", "Исследование было отправлено на обработку.");
      const formData = new FormData();
      formData.append("archive", e.target.files[0]);
      uploadFile(formData, (event: { loaded: number; total: number }) => {
        setProgress(Math.trunc((100 * event.loaded) / event.total));
      });
    }
  };

  return (
    <>
      <h2>Загрузка файла для обучения</h2>
      <hr />
      <div className="frame">
        <h6 className="mb-3">
          1. Загрузите zip архив с исследованием для выбора опций
        </h6>
        <div className="center">
          <div className="dropzone">
            <img
              src={"/upload.svg"}
              alt="upload-icon"
              className="upload-icon"
            />
            <input
              accept=".zip"
              onChange={(e) => changeHandler(e)}
              type="file"
              className="upload-input"
              required={true}
            />
          </div>
          {isFilePicked && (
            <>
              <br />
              <ProgressBar progress={progress} done={success} />
            </>
          )}
        </div>
      </div>
      {success && (
        <div className="frame">
          <h3>Успешно загружено</h3>
        </div>
      )}
    </>
  );
};
